import { getLanguageCode } from "@gtmhub/localization";
import { ShortNumberPipe } from "@webapp/shared/pipes/short-number/short-number.pipe";

export type ValueFormatOptions = {
  fractionSize: number;
  maxFractionDigits: number;
};

export const formatValue = (value: number, shortNumberPipe: ShortNumberPipe, options: ValueFormatOptions): string => {
  const { fractionSize, maxFractionDigits } = options;
  const shortNumberPipeLowerLimit = 10000;
  const maximumFractionDigits = fractionSize === -1 ? maxFractionDigits : fractionSize;

  if (Math.abs(value) < shortNumberPipeLowerLimit) {
    return value.toLocaleString(getLanguageCode(), { maximumFractionDigits });
  } else {
    return shortNumberPipe.transform(value);
  }
};
